import React from 'react';
import { ISmartProps } from './types';
import { View } from './view';
import { headerShortcuts as shortcuts } from './shortcuts/headerShortcuts'

export type HeaderProps = Omit<ISmartProps, 'css'>;
export { EPOLogo, EPOLogoBase64 } from './EPOLogo'

export const Header = (props: HeaderProps) => {
	return <View {...props} />;
};

export const headerShortcuts = shortcuts;
